import { useState } from "react";
import Sidebar from "./Sidebar";
import Contractors from "./Contractors";
import Orders from "./Orders";
import Planning from "./Planning";
import Pickup from "./Pickup";
import Packages from "./Packages";

export default function Layout({ user, onLogout }) {
  const [activePage, setActivePage] = useState(
    user.role_id === "1" ? "orders" : "pickup"
  );
  const [collapsed, setCollapsed] = useState(false);

  const renderPage = () => {
    // If role 2, only allow pickup page
    if (user.role_id === "2") {
      if (activePage === "pickup") return <Pickup />;
      return null; // prevent rendering anything else
    }

    // Admin pages
    switch (activePage) {
      case "contractors":
        return <Contractors />;
      case "orders":
        return <Orders />;
      case "planning":
        return <Planning />;
      case "pickup":
        return <Pickup />;
      case "packages":
        return <Packages />;
      default:
        return <Planning />;
    }
  };


<main
  className={`min-h-screen overflow-auto bg-green-50 p-3
  ${collapsed ? "ml-20" : "ml-64"}`}
>
  {renderPage()}
</main>


  return (
    <div className="flex min-h-screen bg-green-50">
      <Sidebar
        user={user}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        activePage={activePage}
        setActivePage={setActivePage}
        onLogout={onLogout}
      />
      <main
        className={`min-h-screen overflow-auto bg-green-50 p-3
        ${collapsed ? "ml-20 w-[calc(100%-5rem)]" : "ml-64 w-[calc(100%-16rem)]"}`}
      >
        {renderPage()}
      </main>
    </div>
  );
}